module.exports = __webpack_public_path__ + "static/img/download_back5.0fce9906.png";